import React, { useState, useEffect, useLayoutEffect } from "react";
import { useFormik } from "formik";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { areasTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import Filters from "components/Filters";
import XGrid from "components/UI/Grid/XGrid";
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import { RNHZonaGet } from "services/services-mia/programa-salud/estructuras/RNHZonaGet";
import { RNHAreaGet } from "services/services-mia/programa-salud/estructuras/RNHAreaGet";

export default function AreasPrograma() {
  const credentials = useRecoilValue(userCredentials);
  const setRoute = useSetRecoilState(routeInfo);
  const [zonas, setZonas] = useState([]);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [loading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const { service } = useService();

  const formik = useFormik({
    initialValues: {
      zonaCod: "",
    },
    onSubmit: (values) => {
      getAreas(values)
    },
  })
  const resetForm = () => {
    formik.setFieldValue("zonaCod", "");
    getAreas({})
  };

  const getAreas = async (data = { zonaCod: null }) => {
    setAreas([]);
    setRowSelected({ status: false, row: {} });
    setLoading(true);
    const { data: filter } = await RNHZonaGet(credentials);
    setZonas(filter);
    const { data: result } = await RNHAreaGet(credentials, data);
    // Ya no hay ids: el cod es la clave de negocio. MUI solo pide que `id` sea unico
    // dentro del set, no que sea numerico, asi que el cod hace de id de fila.
    const newRows = result[0]?.rnhAreaCod ? result?.map((data) => {
      return {
        id: data.rnhAreaCod,
        name: data.rnhAreaNombre,
        cod: data.rnhAreaCod,
        zonaName: data.rnhZonaNombre,
        zonaCod: data.rnhZonaCod,
        // No son columnas: viajan en la row para que el Upd no tenga que re-consultar.
        version: data.rnhAreaVersion,
        wkt: data.rnhAreaWKT,
        hospitalCabecera: data.rnhEstablecimientoCabeceraAreaNombre || 'Sin asignar'
      };
    }) : []
    setAreas(newRows);
    setLoading(false);
  }
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };
  
  useEffect(() => {
    getAreas()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useLayoutEffect(() => {
    setRoute({
      wordKey: `Áreas - Programa Salud RN`
    })
  }, [service.servicioNombre, setRoute])
  return (
    <main className={styles.main}>
      <Modal size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            row={rowSelected.row}
            updateList={getAreas}
            closeModal={closeModal}
            filtro={zonas}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getAreas}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
            filtro={zonas}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getAreas}
            closeModal={closeModal}
            filtro={zonas}
          />
        )}
      </Modal>
      <div className={styles["filters-actions"]}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Filters
            formik={formik}
            inputsRender={
              [
                { type: "select", name: "zonaCod", label: "Zona", disabled: false, options: zonas, firtsOptionKey: "rnhZonaCod", firstOptionName: "rnhZonaNombre", firstOptionValue: "rnhZonaCod" },
              ]
            }
            disabled={loading}
          />
          <HeaderButton text={"Borrar filtros"} onClick={() => resetForm()} disabled={loading} ><FilterAltOffRoundedIcon /></HeaderButton>
        </div>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getAreas() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Nueva Área"}
            handleClick={handleClick}
            data={{
              title: "Nueva Área",
              procede: ACTIONS.INSERT
            }}
            disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Área"}
            handleClick={handleClick}
            data={{
              title: "Modificar Área",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Área"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Área",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRoundedIcon />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={styles.container}>
        <XGrid
          rows={areas}
          titles={titles}
          loading={loading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}